<h2 mat-dialog-title mat-dialog-draggable-special>
  {{'view_pdf.screen_name' | translate}} {{documentName}}
  <button type="button" class="close" [mat-dialog-close]="true" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<div class="text-center">
  <button mat-icon-button color="primary" (click)="pdfSize = pdfSize + 0.1" [disabled]="pdfSize &gt; 3"
    [matTooltip]="'enterprise_contract.buttons.zoom_in' | translate">
    <mat-icon>zoom_in</mat-icon>
  </button>
  <button mat-icon-button color="primary" (click)="pdfSize = pdfSize - 0.1" [disabled]="pdfSize &lt; 0.4"
    [matTooltip]="'enterprise_contract.buttons.zoom_out' | translate">
    <mat-icon>zoom_out</mat-icon>
  </button>
</div>
<mat-dialog-content class="document" #focus tabindex="-1">
  <div class="pt-3 pb-3" style="transform-origin: left top; height: calc(100vh - 50px);"
    [style.transform]="'scale(' + pdfSize + ')'">
    <div *ngIf="src" class="doc-wrapper view-document-type" style="background-color: #fff;"
      [innerHTML]="src | noSanitize"></div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="center" class="mt-2">
  <button mat-stroked-button color="primary" class="mr-3" type="button" [mat-dialog-close]="true">
    <mat-icon class="mr-0">cancel</mat-icon>{{'view_pdf.buttons.close' | translate}}
  </button>
</mat-dialog-actions>